"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornTabsFilter = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var morse_react_1 = require("morse-react");
var TabContainer = function (props) {
    return jsx_runtime_1.jsx("div", __assign({ className: 'c-tabbed' }, { children: props.children }), void 0);
};
var TabMenu = react_1.forwardRef(function (props, _) {
    return jsx_runtime_1.jsx(morse_react_1.Tab.Menu, __assign({ className: '+primary' }, { children: props.children }), void 0);
});
var TabItem = function (props) {
    var value = props.option.label;
    return (jsx_runtime_1.jsxs(morse_react_1.Tab.MenuItem, __assign({ current: props.isSelected, onClick: props.onSelect }, { children: [value, " ", props.option.item.count !== undefined && jsx_runtime_1.jsx("span", __assign({ className: "c-pill" }, { children: props.option.item.count }), void 0)] }), void 0));
};
var AcornTabsFilter = function (props) {
    return (jsx_runtime_1.jsx(morse_react_1.Select, __assign({}, props, { multiple: false, components: {
            Option: TabItem,
            CollapsedControlContainer: morse_react_1.NoContentControl,
            OptionsPanel: morse_react_1.NoPanel,
            DropDownContainer: TabMenu,
            OptionContainer: morse_react_1.NoWrapperControl,
            OuterMostContainer: TabContainer,
        } }), void 0));
};
exports.AcornTabsFilter = AcornTabsFilter;
//# sourceMappingURL=AcornTabsFilter.js.map